import { init, captureMessage } from '@sentry/browser';

if (process.env.NODE_ENV !== 'development') {
  init({ dsn: process.env.SENTRY_DSN });
  // js全体的なエラーについてはここで補足する
  window.onerror = function (message, fileName, lineNumber, columnNumber, error) {
    captureMessage(message + '\n' +
      fileName + ':' + lineNumber + ':' + columnNumber + '\n' +
      error.stack);
    return true;
  };
}

